export interface BusinessInformation {
  nome: string;
  nu_contrato: string;
  nm_grupoeconomico: string;
  valor: string;
  cd_fatura: string;
  nu_fatura: string;
  valor_comissao: string;
  st_pagamento: string;
  nm_razaosocial: string;
  dt_faturamento: string;
  nu_pedido: string;
}

export interface Commissioned {
  codigo_sap: string;
  nome: string;
  quantidade_parcelas: string;
  valor: string;
  tipo: string;
  funcao: string;
  total_de_comissao: string;
  percentual_de_comissao: string;
}

export interface Invoices {
  id_fatura: string;
  cd_fatura: string;
  nu_fatura: string;
  valor_comissao: string;
  percentual_de_comissao: string;
  status: InvoiceStatus | string;
  dt_faturamento: string;
  status_badge: string;
}

export interface ContractBusinessInformation {
  comissionado: Commissioned;
  faturas: Invoices[];
}

// eslint-disable-next-line no-shadow
export enum InvoiceStatus {
  EM_ABERTO,
  PAGO,
  VENCIDO,
}
